import React from 'react-v18';
import { createRoot } from 'react-dom-v18/client';
import Player from './Player';

export default class PlayerController {
    init() {
        let root = document.getElementById('pod-player');
        const data = root.dataset;

        createRoot(document.getElementById('pod-player')).render(<Player
            {...data}
        />);
    }
}